import type {FunctionComponent} from 'react';
import {useMemo} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {useLocation} from '@app/hooks/use-location';

import {LandingSection} from '@tempo/landing';
import type {Article} from '@app/components/faq';
import {LandingSeoFaq} from '@app/components/faq';

export const FAQ: FunctionComponent = () => {
	const {t} = useTranslation();
	const {getDeezerUrl} = useLocation();

	const articles = useMemo<Article[]>(
		() => [
			{
				title: t(
					'lyricslandingpagefaq_text_Qwhichdevicescompatiblewithlyrics_standalone-web',
					{
						ns: 'lyrics',
					},
				),
				answer: [
					t(
						'lyricslandingpagefaq_text_Awhichdevicescompatiblewithlyrics_standalone-web',
						{ns: 'lyrics'},
					),
					t('genericbulletlistitem_text_iosandroidmobileapps_standalone-web', {
						ns: 'common',
					}),
					t('genericbulletlistitem_text_deezerdesktopapp_standalone-web', {
						ns: 'common',
					}),
					t('genericbulletlistitem_text_selecttvmodels_standalone-web', {
						ns: 'common',
					}),
					t(
						'genericfaqanswer_text_formoreinfocheckXsupportarticle_standalone-web',
						{
							sprintf: [`href=${getDeezerUrl('/support')}`],
							ns: 'common',
						},
					),
				],
				html: true,
			},
			{
				title: t(
					'lyricslandingpagefaq_text_Qcanisearchforasongbasedonitslyrics_standalone-web',
					{
						ns: 'lyrics',
					},
				),
				answer: [
					t(
						'lyricslandingpagefaq_text_Acanisearchforasongbasedonitslyrics_standalone-web',
						{
							sprintf: [
								'href=https://support.deezer.com/hc/en-gb/articles/214151665-Search',
							],
							ns: 'lyrics',
						},
					),
				],
				html: true,
			},
			{
				title: t(
					'lyricslandingpagefaq_text_Qhowdoisharelyricsonsocial_standalone-web',
					{ns: 'lyrics'},
				),
				answer: [
					t(
						'lyricslandingpagefaq_text_Ahowdoisharelyricsonsocial_standalone-web',
						{
							sprintf: [
								'href=https://support.deezer.com/hc/en-gb/articles/115004271149-Play-And-Share-Lyrics',
							],
							ns: 'lyrics',
						},
					),
				],
				html: true,
			},
			{
				title: t(
					'lyricslandingpagefaq_text_Qwhydontiseethelyrics_standalone-web',
					{ns: 'lyrics'},
				),
				answer: [
					t('lyricslandingpagefaq_text_Awhydontiseethelyrics_standalone-web', {
						ns: 'lyrics',
					}),
				],
			},
			{
				title: t(
					'lyricslandingpagefaq_text_Qwhydontiseetranslatedlyrics_standalone-web',
					{ns: 'lyrics'},
				),
				answer: [
					t(
						'lyricslandingpagefaq_text_Awhydontiseetranslatedlyrics_standalone-web',
						{ns: 'lyrics'},
					),
				],
			},
		],
		[t, getDeezerUrl],
	);
	return (
		<LandingSection isContained>
			<LandingSeoFaq articles={articles} />
		</LandingSection>
	);
};
